<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      formRespostasEmpresaReferencia: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        empresaReferencia: this.campos(),
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.empresaReferencia.nome != ''){
          return false
        }
        if(this.empresaReferencia.endereco != ''){
          return false;
        }
        if(this.empresaReferencia.telefone != ''){
          return false
        }
        if(this.empresaReferencia.nomePessoaContato != ''){
          return false;
        }

        return true;
      },
      deletar(indice) {
        this.formRespostasEmpresaReferencia.splice(indice, 1);
      },
      editar(indice) {
        const empresaReferencia = this.formRespostasEmpresaReferencia[indice];
        this.formRespostasEmpresaReferencia.splice(indice, 1);

        this.empresaReferencia.id = empresaReferencia.id;
        this.empresaReferencia.nome = empresaReferencia.nome;
        this.empresaReferencia.endereco = empresaReferencia.endereco;
        this.empresaReferencia.telefone = empresaReferencia.telefone;
        this.empresaReferencia.nomePessoaContato = empresaReferencia.nomePessoaContato;
    
      },
      async adicionar() {
        const copiaEmpresaReferencia = Object.assign(this.empresaReferencia);
        
        this.empresaReferencia = this.campos();
        
        this.formRespostasEmpresaReferencia.push(copiaEmpresaReferencia);

        this.$validator.reset();
      },
      campos() {
        return {
          id: '',
          nome: '',
          endereco: '',
          telefone: '',
          nomePessoaContato: '',
        }
      }
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Nome da Empresa</th>
            <th>Endereço</th>
            <th>Telefone</th>
            <th>Nome Pessoa Contato</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(empresaReferencia, indice) in formRespostasEmpresaReferencia">
            <td>{{ empresaReferencia.nome }}</td>
            <td>{{ empresaReferencia.endereco }}</td>
            <td>{{ empresaReferencia.telefone }}</td>
            <td>{{ empresaReferencia.nomePessoaContato }}</td>

            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="formRespostasEmpresaReferencia.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">Nome da Empresa</label>

          <input type="text"
                 class="form-control"
                 id="nome"
                 maxlength="100"
                 v-model="empresaReferencia.nome"
                 data-vv-name="nome"
                 data-vv-as="nome da empresa"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
        </div>
      </div>


        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('enderecoEmpresaReferencia')}">
            <label class="control-label" for="enderecoEmpresaReferencia">Endereço</label>

            <input type="text"
                   class="form-control"
                   id="enderecoEmpresaReferencia"
                   maxlength="200"
                   v-model="empresaReferencia.endereco"
                   data-vv-name="endereco"
                   data-vv-as="endereço"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('enderecoEmpresaReferencia')">{{ errors.first('enderecoEmpresaReferencia') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('telefone')}">
            <label class="control-label" for="telefone">Telefone</label>

            <input type="text"
                   class="form-control"
                   id="telefone"
                   maxlength="20"
                   v-model="empresaReferencia.telefone"
                   data-vv-name="telefone"
                   v-mascara="'telefone'"
                   data-vv-as="telefone"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('telefone')">{{ errors.first('telefone') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group required" :class="{'has-error': errors.has('nomePessoaContato')}">
            <label class="control-label" for="nomePessoaContato">Nome Pessoa Contato</label>

            <input type="text"
                   class="form-control"
                   id="nomePessoaContato"
                   v-model="empresaReferencia.nomePessoaContato"
                   maxlength="100"
                   data-vv-name="nomePessoaContato"
                   data-vv-as="nome pessoa contato"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('nomePessoaContato')">{{ errors.first('nomePessoaContato') }}</p>
          </div>
        </div>
      </div>
    

      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <button type="button"
                    class="btn btn-success"
                    @click="validar">
              <i class="fa fa-plus"></i> Adicionar Empresa
            </button>
          </div>
        </div>
      </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormRespostasEmpresaReferencia.vue